






























































import { Prop, Component, Vue } from "vue-property-decorator";
import { FolderEntry, Breadcrumb } from "@/models/file";

import VFolder from "@/components/file/VFolder.vue";
import VFolderEntry from "@/components/file/VFolderEntry.vue";
import VFolderEntryEdit from "@/components/file/VFolderEntryEdit.vue";
import VFolderPath from "@/components/file/VFolderPath.vue";

@Component({
  components: {
    VFolder,
    VFolderEntry,
    VFolderEntryEdit,
    VFolderPath
  }
})
export default class FileExplorer extends Vue {
  @Prop({ default: () => [] }) breadcrumbs!: { entryId: any; name: string }[];
  @Prop({ default: () => [] }) entries!: FolderEntry[];
  @Prop({ default: false }) editable!: boolean;
  @Prop({ default: true }) read?: boolean;
  @Prop({ default: "" }) allowExtensions!: string;
  @Prop({ default: true }) editFolder?: boolean;
  @Prop({ default: false }) isEstimateTemplate?: boolean;
  @Prop({ default: [] }) fields?: [];
  @Prop({ default: 0 }) currenFolderId?: number;

  inEdit = false;
  isEnter = false;
  // droppedFiles = [];

  mounted() {
    this.updateEditableClass();
  }

  updateEditableClass() {
    const mainElement = document.querySelector(".file-explorer .main");

    if (!mainElement) return;
    if (this.editable) {
      mainElement.classList.remove("not-editable");
    } else {
      mainElement.classList.add("not-editable");
    }
  }

  open(entry: FolderEntry) {
    this.$emit("open", entry);
  }

  mv(id: any, folderId: any) {
    if (id === folderId) return;
    this.$emit("mv", id, folderId);
  }

  cd(b: Breadcrumb) {
    this.$emit("open", { entryId: b.id, name: b.name, kind: "folder" });
  }

  rename(entry: FolderEntry, name: string) {
    this.$emit("rename", entry, name);
  }

  remove(entry: FolderEntry) {
    this.$emit("remove", entry);
  }

  renameFolder(entry: FolderEntry, name: string) {
    this.$emit("renameFolder", entry, name);
  }

  removeFolder(entry: FolderEntry) {
    this.$emit("removeFolder", entry);
  }

  // ドラッグ、ドロップ時の動作を規定
  dragEnter() {
    if (this.editable) {
      this.isEnter = true;
    }
  }
  dragLeave() {
    this.isEnter = false;
  }
  dropFile(event: any) {
    let droppedFiles: File[] = event.dataTransfer.files;
    // console.log("Files Dropped :", droppedFiles);
    if (droppedFiles[0]) {
      Array.from(droppedFiles).forEach(droppedFile => {
        // console.log("File :", droppedFile);
        if (this.allowExtensions != "*") {
          if (!droppedFile.name.match(".(" + this.allowExtensions + ")$")) {
            alert(
              "拡張子が " +
                this.allowExtensions.split("|") +
                " 以外のファイルはアップロードできません。"
            );
            this.isEnter = false;
            return; // 処理を中断
          }
        }
      });
      if (this.isEnter) {
        this.$emit("uploadDroppedFile", droppedFiles);
      }
    }
    this.isEnter = false;
  }

  dropToBreadcumb(e: DragEvent) {
    if (!e) return;

    const targetId = (e.target as Element).getAttribute("data-id");
    const id = e.dataTransfer ? e.dataTransfer.getData("id") : null;
    if (!targetId || !id) return;

    this.mv(id, targetId);
  }
}
